export const openEmailMailTo = (email: string | undefined): void => {
  if (email) {
    window.open(`mailto:${email}`)
  }
}
